import { ChangeEvent } from "react";

import { PatientEdit } from "@/Common/Components/Patient/PatientEdit";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ButtonImageControl } from "../Buttons/ButtonImageControl";
import { IndividualAdvancedSearchControl } from "../Search/IndividualAdvancedSearchControl";
import { ISidebarProps } from "./Sidebar";

import img_icon_create_patient from "@/Globals/_images/icons/sidebar/create-patient.png";

class SidebarExpandedSearch extends React.Component<ISidebarProps, never> {
    public render(): JSX.Element {
        var createMode = this.props.Model.get("IsCreateMode");
        let patientEdit: JSX.Element;

        if (createMode) {
            patientEdit = (
                <PatientEdit
                    id="sbar"
                    cssClass="sidebar"
                    cancelOperation={LocalOperations.Sidebar.CreatePatient_Cancel}
                    patientModel={this.props.Model.get("PatientCreationModel")}
                    saveOperation={LocalOperations.Sidebar.CreatePatient_Save}
                    duplicatePromptLabelName="DuplicateSentencePromptSidebarLabel"
                    duplicateContinueOperation={LocalOperations.Sidebar.Select_Patient_Duplicate}
                    hideFooter={false}
                />
            );
        }

        var result: JSX.Element = null;

        if (createMode) {
            result = (
                <div id="__sbc" className="sidebar-container">
                    <div style={{ marginTop: "30px" }}>{patientEdit}</div>
                </div>
            );
        }
        else {
            result = (
                <div className="sidebar-container advanced">
                    <div className="tb h">
                        <div className="tbc r1">
                            <div className="search-field">
                                <div className="gf">
                                    <span className="glyphicon glyphicon-search" />
                                </div>
                                <input type="text" data-cy="sidebarExpandedSearch-patient-input" value={this.props.Model.get("SearchText")} onChange={this.onSearchTextChange.bind(this)} placeholder={cacheStore.GetString("SearchLabel")} />
                            </div>
                        </div>
                    </div>
                    <div className="patient-create-options flex-container">
                        <div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" checked={this.props.Model.get("SearchIsInactiveSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchIsInactiveChanged)} />
                                    {cacheStore.GetString("DeactivatedFilesLabel")}
                                </label>
                            </div>
                            {cacheStore.ClinicSettings.EnableRelations && (
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.props.Model.get("SearchInRelativesSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchInRelativesChanged)} />
                                        {cacheStore.GetString("ExternalRelationsLabel")}
                                    </label>
                                </div>
                            )}
                            {cacheStore.ClinicSettings_Portal.EnablePortalWebsite && (
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.props.Model.get("SearchInPortalSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchInPortalChecked)} />
                                        {cacheStore.GetString("PortalSearchLabel")}
                                    </label>
                                </div>
                            )}
                        </div>
                        <div>
                            {patientStore.CanCreatePatient && (
                                <div>
                                    {/** quick hack to disable patient edit for certain clinics... **/}
                                    <ButtonImageControl
                                        onClick={() => sessionStore.dispatch(LocalOperations.Sidebar.CreatePatient)}
                                        imagePath={img_icon_create_patient}
                                        id="createPatient"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="patient-sidebar-search-container full-size" data-cy="sidebarExpandedSearch-searchContainer-div">
                        <IndividualAdvancedSearchControl
                            componentId="_patientAdvancedSearchLabAssociation"
                            defaultTextValue={this.props.Model.get("SearchText")}
                            maxResultsToReturn={6}
                            onIndividualSelectedOperation={LocalOperations.Sidebar.Select_Patient}
                            isFocusOnLoad={true}
                            isRenderTextbox={false}
                            isScrollBarActive={true}
                            isClickOnResultDisabled={this.props.SearchResultClickDisabled}
                            isAutoResize={true}
                            isIncludingInactiveIndividuals={this.props.Model.get("SearchIsInactiveSelected")}
                            isSearchingPortal={this.props.Model.get("SearchInPortalSelected")}
                            isSearchingRelatives={this.props.Model.get("SearchInRelativesSelected")}
                            isSearchingPatients={!this.props.Model.get("SearchInRelativesSelected")}
                            isPortalSearchIncludeAlreadyLinked={true}
                        />
                    </div>
                    <div id="showAdvanceSearchResults"><a onClick={this.OnToggleAdvancedSearch.bind(this)}>{cacheStore.GetString("HideAdvancedSearchResultsLabel")}</a></div>
                </div>
            );
        }

        return result;
    }

    private OnToggleAdvancedSearch(e: React.MouseEvent): void {
        e.preventDefault();
        LocalEvent.Dispatch(LocalOperations.Sidebar.ToggleAdvancedSearch);
    }

    private onSearchTextChange(e: ChangeEvent<HTMLInputElement>): void {
        var o = new LocalEvent(LocalOperations.Sidebar.SearchTextChanged);
        o.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(o);
    }
}

export { SidebarExpandedSearch };
